// import React from 'react';

// const Alert = ({ alert }) => {
//   return (
//     alert !== null && (
//       <div className={`alert alert-${alert.type} bg-danger`}>
//         <i className='fa fa-info-circle'></i> {alert.msg}
//       </div>
//     )
//   );
// };

// export default Alert;
//REFORMING WITH CONTEXT//////////////////////////////

import React, { useContext } from 'react';
import AlertContext from '../../context/alert/alertContext';

const Alert = () => {
  const alertContext = useContext(AlertContext);
  const { alert } = alertContext;
  return (
    alert !== null && (
      <div className={`alert alert-${alert.type} bg-danger`}>
        <i className='fa fa-info-circle'></i> {alert.msg}
      </div>
    )
  );
};

export default Alert;
